import React from 'react';
import AiExplanation from './AiExplanation';

const interpretationSets = {
  TEP: [
    {
      title: 'Modelo de duas categorias',
      levels: [
        { label: 'TEP improvável', range: 'Até 4 pontos', active: (score) => score <= 4, tone: 'low' },
        { label: 'TEP provável', range: 'Acima de 4 pontos', active: (score) => score > 4, tone: 'high' },
      ],
    },
    {
      title: 'Modelo de três categorias',
      levels: [
        { label: 'Baixa probabilidade', range: 'Abaixo de 2 pontos', active: (score) => score < 2, tone: 'low' },
        { label: 'Moderada probabilidade', range: 'De 2 a 6 pontos', active: (score) => score >= 2 && score <= 6, tone: 'moderate' },
        { label: 'Alta probabilidade', range: 'Acima de 6 pontos', active: (score) => score > 6, tone: 'high' },
      ],
    },
  ],
  TVP: [
    {
      title: 'Modelo de três categorias',
      levels: [
        { label: 'Baixa probabilidade', range: '0 ponto ou menos', active: (score) => score <= 0, tone: 'low' },
        { label: 'Moderada probabilidade', range: 'De 1 a 2 pontos', active: (score) => score >= 1 && score <= 2, tone: 'moderate' },
        { label: 'Alta probabilidade', range: '3 pontos ou mais', active: (score) => score >= 3, tone: 'high' },
      ],
    },
  ],
};

function ResultSection({ total, selectedItems, type }) {
  return (
    <aside className="result-panel" aria-live="polite">
      <div className="result-topline">
        <h2>Resultado Wells {type}</h2>
        <span className="result-total">{total}</span>
      </div>
      <p className="result-caption">pontuação total</p>

      <div className="interpretation-list">
        {interpretationSets[type].map((model) => (
          <section className="interpretation-model" key={model.title}>
            <h3>{model.title}</h3>
            {model.levels.map((level) => (
              <div
                className={`interpretation-row ${level.active(total) ? `is-active tone-${level.tone}` : ''}`}
                key={level.label}
              >
                <span>{level.label}</span>
                <span>{level.range}</span>
              </div>
            ))}
          </section>
        ))}
      </div>

      <div className="selected-criteria">
        <h3>Critérios marcados</h3>
        {selectedItems.length ? (
          <ul>
            {selectedItems.map((item) => (
              <li key={item.id}>
                <span>{item.label}</span>
                <strong>
                  {item.points > 0 ? '+' : ''}
                  {item.points}
                </strong>
              </li>
            ))}
          </ul>
        ) : (
          <p>Marque os critérios avaliados para acompanhar a soma.</p>
        )}
      </div>

      <p className="clinical-warning">
        Wells estima probabilidade pré-teste. A interpretação de algoritmos
        posteriores depende do contexto, do D-dímero, da idade, do protocolo e
        da disponibilidade de imagem. Nunca use o escore sozinho para excluir
        ou confirmar {type}.
      </p>

      <AiExplanation selectedItems={selectedItems} type={type} />
    </aside>
  );
}

export default ResultSection;
